import { Component, OnInit, Input } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Router } from "@angular/router";
import { OpAdminCategoriesService } from "../../services/op-admin-categories.service";

@Component({
  selector: "app-op-continue-shopping-pop-up",
  templateUrl: "./op-continue-shopping-pop-up.component.html",
  styleUrls: ["./op-continue-shopping-pop-up.component.css"],
})
export class OpContinueShoppingPopUpComponent implements OnInit {
  @Input() title: string;
  @Input() message: string;
  @Input() btnOkText: string;
  @Input() btnCancelText: string;
  tabNames = {
    'packages': 'Multi Image Packages',
    'gifts': 'Multi Image Packages',
    'individuals': 'Individual Products'
  };

  storeType: any;
  constructor(private activeModal: NgbActiveModal, private router: Router, public categoryService: OpAdminCategoriesService) {}

  ngOnInit() {
    this.storeType = sessionStorage.getItem("store_type");
    this.storeCategoriesList();
  }

  storeCategoriesList() {
    this.categoryService.getAllStoreCategories().subscribe((data: any) => {
      data.data.forEach((item) => {
        if (item.type == 'packages') {
          this.tabNames.packages = item.name;
        }
        if (item.type == 'gifts') {
          this.tabNames.gifts = item.name;
        }
        if (item.type == 'individuals') {
          this.tabNames.individuals = item.name;
        }
      });
    });
  }

  routeProductList() {
    // this.router.navigate(["/WebPanel/productListing"], {
    //   queryParams: { id: 1 },
    // });
    this.decline(true);
  }

  GoToOverview() {
    this.router.navigateByUrl("/WebPanel/proofcard");
    this.decline(false);
  }

  GoToPacks() {
    if (this.storeType == "Nursery") {
      this.router.navigateByUrl("/WebPanel/nursery-shop/packages");
    } else {
      this.router.navigateByUrl("/WebPanel/school-shop/packages");
    }

    this.decline(false);
  }

  GoToGifts() {
    if (this.storeType == "Nursery") {
      this.router.navigateByUrl("/WebPanel/nursery-shop/gifts");
    } else {
      this.router.navigateByUrl("/WebPanel/school-shop/gifts");
    }

    this.decline(false);
  }

  GoToProds() {
    if (this.storeType == "Nursery") {
      this.router.navigateByUrl("/WebPanel/nursery-shop/individuals");
    } else {
      this.router.navigateByUrl("/WebPanel/school-shop/individuals");
    }
    this.decline(false);
  }

  public decline(action) {
    this.activeModal.close(action);
  }

  public accept() {
    this.activeModal.close(true);
  }

  public dismiss() {
    this.activeModal.dismiss();
  }
}
